export const getLocationOptions = (store) => {
  const locations = store.location.locations;

  return locations.map((item) => ({ value: item._id, label: `${item.name} (${item?.area?.name ?? '-'})` }));
};
